export default "__VITE_ASSET__CGO73aIF__"